import moment from "moment";
import { required, requiredIf } from "vuelidate/lib/validators";
import { nanoid, customAlphabet } from 'nanoid'
import lodash from 'lodash';
import deepdash from 'deepdash';
import Hashids from 'hashids'
import { urlValidator, htmlValidator, emailValidator, phoneValidator, uNCValidator } from "./validator";

/* assets */
import defaultProfileImage from "../../assets/images/default/default-profile.png";
import fetiasLogo from "../../assets/images/logo/inistate-logo.png";

const _ = deepdash(lodash);
const hashids = new Hashids('', 10)

moment.updateLocale("en", {
  relativeTime: {
    future: "%s",
    past: "%s",
    s: 'few sec',
    ss: '%d sec',
    m: "1 min",
    mm: "%d min",
    h: "1 hr",
    hh: "%d hr",
    d: "1 d",
    dd: "%d d",
    w: "1 wk",
    ww: "%d wk",
    M: "1 mo",
    MM: "%d mo",
    y: "1 yr",
    yy: "%d yr"
  }
});

const iOSAppStoreURL = "https://apps.apple.com/app/fetias/id1448325160";
const androindPlayStoreURL = "https://play.google.com/store/apps/details?id=com.gneysoftware.fetias_mobile";
const websiteURL = "https://inistate.com/home";
const communityURL = "https://community.fetias.com/";
const youtubeURL = "https://www.youtube.com/channel/UCADsnXVnVkOBhR-haVDo65w";
const facebookURL = "https://www.facebook.com/inistatehq";
const twitterURL= "https://twitter.com/inistatehq";
const linkedinURL= "https://sg.linkedin.com/company/inistate";
const discordURL = "https://discord.com/invite/e6TFF2Qexk";
const blogURL = "https://blog.inistate.com/";

// Information Types
const informationTypes = [
  { id: 0, type: 'Text', type: 'Text', input: 'text', icon: 'fts-icon-text', iconL: 'text', size: 2, searchable: true, },
  { id: 1, type: 'YesNo', input: 'boolean', icon: 'fts-icon-check-square', iconL: 'boolean', size: 2, searchable: true },
  { id: 2, type: 'Integer', input: 'integer', icon: 'fts-icon-integer', iconL: 'integer', size: 2, searchable: true },
  { id: 3, type: 'Number', input: 'number', icon: 'fts-icon-number', iconL: 'number', size: 2, searchable: true },
  { id: 4, type: 'Money', input: 'number', icon: 'fts-icon-dollar-sign', iconL: 'currency', size: 2, searchable: true },
  { id: 5, type: 'Date', input: 'date', icon: 'fts-icon-calendar', iconL: 'date', size: 2, searchable: true },
  { id: 6, type: 'Date Time', input: 'dateTime', icon: 'fts-icon-calendar', iconL: 'datetime', size: 2, searchable: true },
  { id: 7, type: 'Module', input: 'dropDown', icon: 'fts-icon-locus', iconL: 'locus', additionalInformation: true, size: 2, searchable: true },
  { id: 8, type: 'Locuses', input: 'multidropDown', icon: 'fts-icon-locus', iconL: 'locus', size: 2 },
  { id: 9, type: 'Location', input: 'location', icon: 'fts-icon-map-marker', iconL: 'location', size: 2 },
  { id: 10, type: 'Image', input: 'imageUpload', icon: 'fts-icon-image', iconL: 'image', size: 2 },
  { id: 11, type: 'Images', input: 'imagesUpload', icon: 'fts-icon-image', iconL: 'images', size: 2 },
  { id: 12, type: 'File', input: 'fileUpload', icon: 'fts-icon-paperclip', iconL: 'file', size: 2 },
  { id: 13, type: 'Files', input: 'filesUpload', icon: 'fts-icon-paperclip', iconL: 'files', size: 2 },
  { id: 14, type: 'Table', input: 'table', icon: 'fts-icon-list-table', iconL: 'table', additionalInformation: true, size: 1 },
  { id: 15, type: 'List (Beta)', input: 'list', icon: 'fts-icon-list-table', iconL: 'table', additionalInformation: true, size: 1 },
  { id: 16, type: 'Multiline Text', input: 'textArea', icon: 'fts-icon-text-area', iconL: 'multiline-text', size: 2, searchable: true },
  //Action,
  //Hidden,
  //Username,
  { id: 19, type: 'Username', input: 'username', icon: 'fts-icon-user', iconL: 'user', size: 2, searchable: true, internal: true },
  { id: 20, type: 'Profile (Module)', input: 'dropDown', icon: 'fts-icon-user', iconL: 'user', additionalInformation: true, size: 2, searchable: true },
  //Users
  { id: 22, type: 'Content', input: 'content', icon: 'fts-icon-font-underline', iconL: 'content', size: 2 },
  //{ id: 23, type: 'Checklist', input: 'checklist', icon: 'check-list' },
  { id: 24, type: 'Context', input: 'contextSelection', icon: 'fts-icon-check-square', iconL: 'locus', size: 2 },
  { id: 25, type: 'Email', input: 'email', icon: 'fts-icon-envelope', iconL: 'email', size: 2, searchable: true },
  { id: 26, type: 'Phone Number', input: 'phoneNumber', icon: 'fts-icon-phone', iconL: 'phonenumber', size: 2, searchable: true },
  { id: 27, type: 'Select', input: 'dropDown', icon: 'fts-icon-menu-caret-down', iconL: 'select', additionalInformation: true, size: 2, searchable: true },
  { id: 28, type: 'Tag', input: 'dropDown', icon: 'fts-icon-menu-times', iconL: 'select', additionalInformation: true, size: 2 },
  { id: 29, type: 'Signature', input: 'signature', icon: 'fts-icon-signature', iconL: 'signature', size: 2 },
  { id: 30, type: 'Date Range', input: 'dateRange', icon: 'fts-icon-calendar', iconL: 'date', size: 2, internal: true },
  // { id: 31, type: 'DateTimeRange', input: 'dateTimeRange', icon: 'dateTimeRange' },
  { id: 32, type: 'Formula', input: 'formula', icon: 'fts-icon-formula', iconL: 'formula', additionalInformation: true, size: 2, internal: true },
  { id: 33, type: 'Link', input: 'link', icon: 'fts-icon-link', iconL: 'link', size: 2, searchable: true },
  { id: 35, type: 'Form', input: 'form', icon: 'fts-icon-form', internal: true },
  { id: 36, type: 'Table Row', input: 'tableRow', icon: 'fts-icon-table-row', internal: true },
  { id: 37, type: 'Unknown', input: 'unknown', icon: 'fts-icon-unknown', internal: true },
]
/* information type expand */
const informationTypeExpand = [
  { from: 0, to: [16] },
  { from: 1, to: [0] },
  { from: 2, to: [3, 4] },
  { from: 3, to: [4, 0] },
  { from: 4, to: [0] },
  { from: 5, to: [6] },
  { from: 6, to: [0] },
  { from: 10, to: [12, 13, 11, 33] },
  { from: 11, to: [13] },
  { from: 12, to: [13, 33] },
  { from: 13, to: [0] },
  { from: 16, to: [0] },
  { from: 25, to: [0] },
  { from: 26, to: [0] },
  { from: 27, to: [0] },
  { from: 33, to: [0] },
]

const expandInformationType = (item, list) => {
  list = Array.isArray(list) ? [...new Set(list), item] : [item];

  const res = informationTypeExpand.find(x => x.from === item);
  res && res.to.forEach(x => {
    if (!list.some(y => y === x)) {
      list = list.concat(expandInformationType(x, [...list, x]));
    }
    list.push(x)
  });
  
  return [...new Set(list)];
}
// Standard Activities
var standards = [
  { id: 'createEditView', name: 'Create / Edit / View' },
  { id: 'create', name: 'Create' },
  { id: 'edit', name: 'Edit' },
  { id: 'view', name: 'View' },
  { id: 'quickView', name: 'Quick View' },
  { id: 'delete', name: 'Delete' },
  { id: 'changeStatus', name: 'Change Status' },
  { id: 'duplicate', name: 'Duplicate' },
  { id: 'comment', name: 'Comment' },
  { id: 'history', name: 'History' },
  { id: 'assign', name: 'Assign', beta: true },
  { id: 'import', name: 'Import', beta: true },
  { id: 'print', name: 'Print', beta: true },

];

const standardActivities = [
  { id: "view", name: "View", icon: "fts-icon-file", classification: true, standard: true },
  { id: "create", name: "New", icon: "fts-icon-edit", classification: true, standard: true },
  { id: "edit", name: "Edit", icon: "fts-icon-edit", classification: true, quickView: true, standard: true },
  { id: "delete", name: "Delete", icon: "fts-icon-trash", quickView: true, bulk: true, standard: true },
  { id: "duplicate", name: "Duplicate", icon: "fts-icon-duplicate", standard: true },
  { id: "changeStatus", name: "Change State", icon: "fts-icon-sync", quickView: true, bulk: true, standard: true },
  { id: "assign", name: "Assign", icon: "fts-icon-user-plus", quickView: true, bulk: true, standard: true }
]
// Color
const alphaPalette = [
  "#d50000",
  "#c51162",
  "#aa00ff",
  "#6200ea",
  "#304ffe",
  "#2962ff",
  "#0091ea",
  "#00b8d4",
  "#00bfa5",
  "#00c853",
  "#64dd17",
  "#aeea00",
  "#ffd600",
  "#ffab00",
  "#ff6d00",
  "#dd2c00",
  "#40241a",
  "#000000",
  "#616161",
  "#1c313a",
]
const darkPalette = [
  "#b71c1c",
  "#ad1457",
  "#6a1b9a",
  "#4527a0",
  "#1a237e",
  "#0d47a1",
  "#007ac1",
  "#00838f",
  "#004d40",
  "#2e7d32",
  "#387002",
  "#827717",
  "#f57f17",
  "#ff6f00",
  "#bb4d00",
  "#b91400",
  "#6d4c41",
  "#4e342e",
  "#0f0f0f",
  "#37474f"
]
const lightPalette = [
  "#ff8a80",
  "#ff80ab",
  "#ea80fc",
  "#b388ff",
  "#8c9eff",
  "#82b1ff",
  "#80d8ff",
  "#84ffff",
  "#a7ffeb",
  "#b9f6ca",
  "#ccff90",
  "#f4ff81",
  "#ffff8d",
  "#ffe57f",
  "#ffd180",
  "#ff9e80",
  "#bcaaa4",
  "#b0bec5",
  "#e0e0e0",
  "#eeeeee"
]
const lightenPalette = [
  "#ffd4d9",
  "#f9c5d7",
  "#e5c8eb",
  "#d8cdec",
  "#ced2ec",
  "#c5e3fc",
  "#bee9fc",
  "#bdeef4",
  "#bde4e0",
  "#d0ead1",
  "#e1f0d0",
  "#f2f6cc",
  "#fffacd",
  "#ffefbe",
  "#ffe5bd",
  "#ffd4c6",
  "#e5dedb",
  "#e0e6e8",
  "#e9edef",
  "#f2f2f2"
]
const futurePalette = [
  "#75BDE0",
  "#78D1D2",
  "#97DBAE",
  "#CDE4AD",
  "#3D9A8B",
  "#2EB19F",
  "#63C2D2",
  "#B7EDFF"
]
// Date Format Luxon
const dateFormatSample = `${moment().year()}-03-27`;
const dateFormats = [
  { id: 't', name: moment(dateFormatSample).format('LT'), cSharp: 'h:mm tt' },
  { id: 'D', name: moment(dateFormatSample).format('l'), cSharp: 'M/d/yyyy' },
  { id: 'LL/dd/yyyy', name: moment(dateFormatSample).format('L'), cSharp: 'MM/dd/yyyy' },
  { id: 'd/L/yyyy', name: moment(dateFormatSample).format('D/M/YYYY'), cSharp: 'd/M/yyyy' },
  { id: 'dd/LL/yyyy', name: moment(dateFormatSample).format('DD/MM/YYYY'), cSharp: 'dd/MM/yyyy' },
  { id: 'DD', name: moment(dateFormatSample).format('ll'), cSharp: 'MMM dd, yyyy' },
  { id: 'DDD', name: moment(dateFormatSample).format('LL'), cSharp: 'MMMM dd, yyyy' },
  { id: 'DD t', name: moment(dateFormatSample).format('lll'), cSharp: 'MMM dd, yyyy h:mm tt' },
  { id: 'DDD t', name: moment(dateFormatSample).format('LLL'), cSharp: 'MMMM dd, yyyy h:mm tt' },
  { id: 'ccc, LLL d, yyyy t', name: moment(dateFormatSample).format('llll'), cSharp: 'ddd, MMM dd, yyyy h:mm tt' },
  { id: 'cccc, LLLL d, yyyy t', name: moment(dateFormatSample).format('LLLL'), cSharp: 'dddd, MMM dd, yyyy h:mm tt' },
];

const dateFormatTranslate = ((x) => {
  let dateFormat = x
  if (dateFormat) {
    dateFormat = dateFormat.replace(/\bt\b/g, 'hh:mm a')
    dateFormat = dateFormat.replace(/\bD\b/g, 'L/d/yyyy')
    dateFormat = dateFormat.replace(/\bDD\b/g, 'LLL d, yyyy')
    dateFormat = dateFormat.replace(/\bDDD\b/g, 'LLLL d, yyyy')
  }
  return dateFormat
})

// Moment Relative Time
let momentRelativeTime = function (date) {
  if (validDate(date))
    return moment(date).calendar(null, {
      lastWeek: () => `[${moment(date).fromNow()}]`,
      lastDay: '[yesterday]',
      sameDay: () => `[${moment(date).fromNow()}]`,
      nextDay: '[tomorrow]',
      nextWeek: () => `[${moment(date).fromNow()}]`,
      sameElse: () => `[${moment(date).fromNow()}]`,
    })
}
// calendar relative time
let calendarRelativeTime = function (date) {
  const today = moment().startOf('day');
  if (validDate(date))
    return moment(date).calendar(null, {
      lastWeek: () => moment(today).isSame(date, 'week') ? `[${moment(date).fromNow()}]` : '[last week]',
      lastDay: '[yesterday]',
      sameDay: '[today]',
      nextDay: '[tomorrow]',
      nextWeek: 'ddd',
      sameElse: () => {
        if (moment(moment(today).subtract(7, 'd')).isSame(date, 'week'))
          return '[last week]';
        else if (moment(moment(today).subtract(7, 'd')).isSame(date, 'week'))
          return 'ddd';
        else
          return `[${moment(date).startOf('day').from(today)}]`;
      }
    });
}

// Moment Valid Date
var validDate = (date) => moment(date).isValid();

// Draggable Option
const dragOptions = {
  animation: 150,
  ghostClass: "ghost",
  forceFallback: true,
}

var newUUID = function () {
  // http://www.ietf.org/rfc/rfc4122.txt

  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  return s.join("");
}

const nanoID = function () {
  return nanoid(12)
}

const encodeids = function (ids) {
  return isInteger(ids) ? hashids.encode(ids) : ids
}

const decodeids = function (ids) {
  if (isInteger(ids)) {
    return ids
  } else {
    const decode = hashids.decode(ids)
    return Array.isArray(decode) ? decode[0] : decode
  }
}

var model = function (data, fieldName, forId) {
  let result = null;
  if (fieldName && fieldName.indexOf(".") > -1) {
    var fields = fieldName.split(".");
    result = data;
    for (let i = 0; i < fields.length; i++) {
      if (forId && i == fields.length - 1)
        result = result[fields[i] + "Id"];
      else result = result[fields[i]];
      if (result == null) {
        result = null;
        break;
      }
    }
  } else {
    if (forId) result = data[fieldName + "Id"];
    else result = data[fieldName];
  }

  return result;
}
var numeralFormats = [
  { id: '0,0', name: '10,000' },
  { id: '0,0.00', name: '10,000.00/-10,000.00' },
  { id: '(0,0.00)', name: '10,000.00/(10,000.00)' },
  { id: '0%', name: '100%' },
  { id: '0.00%', name: '100.00%' },
];

let standardActivityIcon = (id => {
  const result = standardActivities.find(x => x.id === id);
  return result && result.icon;
})

let informationIcon = (typeId => {
  switch (typeId) {
    case 'state':
      typeId = 7
      break;
    case 'password':
      typeId = 0
      break;
    case 'toggleSwitch':
      typeId = 1
      break;
  }

  const result = informationTypes.find(x => { return x.id == typeId })
  return result && result.icon
})

// Legacy
let getInformationIcon = (typeId => {
  const result = informationTypes.find(x => { return x.id == typeId })
  return result && result.iconL ? result.iconL.toLowerCase() : ''
})

var camelize = function (str) {
  if (str == null)
    return null

  return str.replace(/\W+/g, '').replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
    return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
  })
}

var displayName = function (text) {
  if (text) {
    text = text.charAt(0).toUpperCase() + text.slice(1);
    return text.replace(/([A-Z])/g, ' $1').trim();
  }
  return ''
}

var fileColor = function (fileName) {
  if (fileName) {
    if (/\.(pdf)$/i.test(fileName))
      return "var(--fts-file-pdf)";
    else if (/\.(doc|docx)$/i.test(fileName))
      return "var(--fts-file-word)";
    else if (/\.(ppt|pptx)$/i.test(fileName))
      return "var(--fts-file-powerpoint)";
    else if (/\.(xlsx|xls|csv)$/i.test(fileName))
      return "var(--fts-file-excel)";
    else if (/\.(jpeg|jpe|jpg|svg|gif|png|webp|bmp|)$/i.test(fileName))
      return "var(--fts-file-image)";
    else if (/\.(html)$/i.test(fileName))
      return "var(--fts-file-html)";
  }
  return "var(--fts-file-default)";
}

var fileExtension = function (fileName) {
  if (fileName) {
    var extension = fileName.split(".").pop();
    return extension.substring(0, 4).toUpperCase();
  }
}

var isImageFile = (val) => /\.(jpeg|jpe|jpg|svg|gif|png|webp|bmp|)$/i.test(val);

const isInteger = (val) => /^\d+$/.test(val);

const isNumber = (val) => !isNaN(parseFloat(val));

const isArray = (val) => Object.prototype.toString.call(val) === "[object Array]";

const isObject = (val) => Object.prototype.toString.call(val) === "[object Object]";

var selectOptionBackground = function (payload) {
  const option = payload.option
  const options = payload.optionList || []
  const text = payload.text

  if (option && typeof option === 'object' && option.color)
    return option.color

  let findOption = null
  if (option == null && text != null)
    findOption = options.find(x => x.name == text)

  if (findOption && typeof findOption === 'object' && findOption.color)
    return findOption.color

  const colors = _.difference(lightenPalette, _.map(options, 'color'))

  let skip = 0
  if (findOption) {
    skip += options.filter(x => !x.color).indexOf(findOption)
  } else if (option == null || typeof option === 'string') {
    skip += options.filter(x => !x.color).length + 1
  } else {
    skip += options.filter(x => !x.color).indexOf(option)
  }

  const colorSize = colors.length
  if (skip > colorSize - 1) {
    skip -= colorSize * Math.trunc(skip / colorSize)
  }

  return colors[skip]
}

var taskDueDateShortcuts = [
  {
    id: "today",
    label: "Today",
    startDate: moment()
      .startOf("day")
      .format(),
    endDate: moment()
      .endOf("day")
      .format()
  },
  {
    id: "tomorrow",
    label: "Tomorrow",
    startDate: moment()
      .add(1, "day")
      .startOf("day")
      .format(),
    endDate: moment()
      .add(1, "day")
      .endOf("day")
      .format()
  },
  {
    id: "next3Day",
    label: "Next 3 Day",
    startDate: moment()
      .add(3, "day")
      .startOf("day")
      .format(),
    endDate: moment()
      .add(3, "day")
      .endOf("day")
      .format()
  },
  {
    id: "nextWeek",
    label: "Next Week",
    startDate: moment()
      .add(1, "week")
      .startOf("day")
      .format(),
    endDate: moment()
      .add(1, "week")
      .endOf("day")
      .format()
  },
  {
    id: "next2Week",
    label: "Next 2 Week",
    startDate: moment()
      .add(2, "week")
      .startOf("day")
      .format(),
    endDate: moment()
      .add(2, "week")
      .endOf("day")
      .format()
  },
  {
    id: "nextMonth",
    label: "Next Month",
    startDate: moment()
      .add(1, "month")
      .startOf("day")
      .format(),
    endDate: moment()
      .add(1, "month")
      .endOf("day")
      .format()
  }
];

var getAllElements = function (elements, form) {
  if (elements == null) {
    elements = [];
  }

  if (form && form.rows != null) {
    form.rows.forEach(row => {
      if (row.items != null) {
        row.items.forEach(item => {
          getAllElementsInternal(elements, item);
        });
      }
    })
  }

  return elements;
}

var getAllElementsInternal = function (elements, item) {
  if (item.input == 'section') {
    //tab
    if (item.type == 'tab' && item.tabs) {
      item.tabs.forEach(tab => {
        if (tab.design) {
          getAllElements(elements, tab.design);
        }
      });
    }
    //design
    else if (item.design) {
      getAllElements(elements, item.design);
    }
  } else if (item && item.id) {
    elements.push(item);
  }

  return elements;
}

var generateFieldName = function () {
  const customId = customAlphabet('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ', 6)
  const id = customId()
  return id[0].toLowerCase() + id.slice(1)
}

let propDowns = [
  /* general */
  'type', 'fieldName', 'displayName',
  /* number */
  'customFormat', 'decimalPlaces',
  /* date / date time */
  'predefinedFormatId',
  /* select */
  'optionList',
  /* module */
  'connectionFieldId', 'connectionId', 'canAddNew', 'allowOther',
  'displayTemplate','valueTemplate',
];

var expandWorkDesignInternal = function (information, item) {
  const elements = ["description", "image", "empty", 'button'];
  // elements that nothing need to be done
  if (item && elements.some(x => x === item.input)) {
    if (!item.id) item.id = nanoID()
    return item
  }
  else if (item.input == 'section') {
    if (!item.id) item.id = nanoID()
    // tab
    if (item.type == 'tab' && item.tabs) {
      item.tabs.forEach(tab => {
        if (!tab.id) tab.id = nanoID()
        if (tab.design) {
          expandWorkDesign(information, tab.design);
        }
      });
    }
    // section, collapsible
    else if (item.design) {
      expandWorkDesign(information, item.design);
    }
  } else if (item && item.id) {
    // deep clone
    let result = information.find(y => y.id == item.id);

    if (result) {
      let informationItem = lodash.cloneDeep(result);
      let fields = informationItem.fields;

      // list expand work design
      if (item.design && fields != null && informationItem.type == 15) {
        expandWorkDesign(informationItem.fields, item.design);
      }

      // table or list
      if (fields != null && fields.length > 0) {
        if (item.fields == null
          || item.fields.length == 0) {
          item.fields = fields;
        } else {
          let fieldIds = fields.map(x => x.id);
          // remove field
          item.fields = item.fields
            .filter(x => fieldIds.indexOf(x.id) > -1)
            .map(field => expandWorkDesignInternal(fields, field));
          // add field
          let itemFieldIds = item.fields.map(x => x.id);
          fields.filter(x => itemFieldIds.indexOf(x.id) < 0)
            .forEach(x =>
              item.fields.splice(fields.findIndex(y => y.id === x.id), 0, x)
            );
        }
      }

      propDowns.forEach(prop => {
        if (
          informationItem[prop] !== null && 
          informationItem[prop] !== undefined && 
          informationItem[prop] !== ''
        ) {
          item[prop] = informationItem[prop];
        }
      });
    }
  }

  return item;
}

var expandWorkDesign = function (information, form) {
  if (form.rows != null) {
    form.rows.forEach(row => {
      if (row.items != null) {
        //everything to be included, no need filter
        row.items = row.items.map(y => expandWorkDesignInternal(information, y));
      }
    })
  }
}

const classificationValuesToKeep = [
  /* general */
  'id', 'hide',  'input', 'label', 'description',
  /* controls */
  'required', 'readOnly', 'visibilityScript',
  'formula', 'requiredFormula', 'readOnlyFormula', 'visibleFormula',
  'addRemoveItems', 'disabledAddRemoveItems', 'due', 'assignee',
  /* module */
  'autoCompleteFormDataFields', 'scriptOnly', 'filter', 'queryScript', 'sort',
  /* money */
  'prefix',
  /* number */
  'decimalPlaces',
  /* table / list */
  'fields',
  /* table */
  'columnWidth',
  /* list */
  'displayField',
  /* date / date time */
  'enableCustomDateFormat', 'customDateFormatId', 'withTime',
  /* module / image / file */
  'allowMultiple',
  /* section */
  'design',
  /* undefined */
  'schedule',
  //button
  'eventName',
];

var removeInheritInformationValue = function (item) {
  for (var key in item) {
    if (!item.custom) {
      if (!classificationValuesToKeep.some(x => x == key)) {
        delete item[key];
      } else if(item[key] === null) {
        delete item[key];
      }
    }
  }

  /* fields */
  if (item.fields != null) {
    item.fields.forEach(column => {
      removeInheritInformationValue(column);
    });
  } else {
    delete item['fields'];
  }

  /* design */
  if (item.design != null) {
    compactWorkDesignInternal(item.design);
  } else {
    delete item['design'];
  }
}

var compactField = function (item) {
  if (item.input == 'section') {
    if (item.type == 'tab') {
      delete item['design'];
      if (item.tabs != null) {
        item.tabs.forEach(tab => {
          compactWorkDesignInternal(tab.design);
        });
      }
    } else {
      delete item['tabs'];
      if (item.design != null) {
        compactWorkDesignInternal(item.design);
      }
    }
  }

  /* element */
  const elements = ["description", "image", "empty", 'button'];
  /* information item */
  if (item.id && item.fieldName && elements.indexOf(item.input) === -1) {
    removeInheritInformationValue(item);
  }

  //form design cloned item from too;
  return item;
}

var compactWorkDesignInternal = function (design) {
  if (design.rows != null) {
    design.rows.forEach(x => {
      if (x.items != null) {
        x.items = x.items.map(y => compactField(y))
      }
    });
  }
}

var compactClassification = function (canvas) {
  /* remove ribbons */
  if (canvas.ribbons && canvas.ribbons.length == 1) {
    if (canvas.ribbons[0].name == 'Initial') {
      delete canvas.ribbons;
    }
  }
  /* activities */
  if (canvas.activities) {
    canvas.activities.forEach(activity => {
      if (activity.design) {
        delete activity.classification;
        compactWorkDesignInternal(activity.design);
      }
    });
  }
  /* standard activities */
  if (canvas.standardActivities) {
    canvas.standardActivities.forEach(activity => {
      if (activity.design) {
        delete activity.classification;
        compactWorkDesignInternal(activity.design);
      }
    });
  }
  /* documents (issue) */
  // if (canvas.documents) {
  //   canvas.documents.forEach(document => {
  //     if (document.design) {
  //       compactWorkDesignInternal(document.design);
  //     }
  //   });
  // }
}

var classificationInformationInternal = (item) => {
  if (item.items) {
    let result = item.items;
    let items = item.items.flatMap(x => {
      if (x.input == "section" && x.type == "tab" && x.tabs) {
        return x.tabs.flatMap((z) => {
          return z.design.rows.flatMap((y) => {
            return classificationInformationInternal(y);
          });
        });
      } else if (x.input == "section" && x.design) {
        return x.design.rows.flatMap((y) => {
          return classificationInformationInternal(y);
        });
      }
    });
    return result.concat(...items);
  } 
  return [];
}

var classificationInformation = (rows, information) => {
  return rows.flatMap(x => classificationInformationInternal(x))
    .map(x => {
      if (x) {
        const item = information.find(y => y.id === x.id);
        if (item) return { ...x, ...item }
      }
    })
    .filter(x => x);
}

var expandInformationFields = function(canvas) {
  /* activities */
  if (canvas.activities) {
    canvas.activities.forEach(activity => {
      if (activity.design) {
        expandWorkDesign(canvas.information, activity.design);
      }
    })
  }
  /* standard activities */
  if (canvas.standardActivities) {
    canvas.standardActivities.forEach(activity => {
      if (activity.design) {
        expandWorkDesign(canvas.information, activity.design);
      }
    })
  }
}

var compactMenuDesign = function (canvas, menu) {
  if (menu && menu.list && menu.list.columns) {
    let menuValuesToKeep = ['id']

    for (var column in menu.list.columns) {
      for (var key in column) {
        if (!menuValuesToKeep.some(x => x == key)) {
          delete column[key];
        }
      }
    }
  }
}

var trimMenu = function (menus) {
  if (menus == null)
    return null;

  return menus.map(menu => {
    if(menu.type == 'group') {
      return {
        'id': menu.id,
        'emoji': menu.emoji,
        'name': menu.name,
        'type': menu.type,
        'children': trimMenu(menu.children)
      };
    } else {
      return {
        'id': menu.id,
      };

    }
  });
}

var visibleMenu = (menus) => {
  return Array.isArray(menus) ? menus.filter(x => {
    if (x.type === 'group') {
      if (x.children && x.children.length > 0) {
        x.children = visibleMenu(x.children);
        return Boolean(x.children.length);
      } else {
        return false;
      }
    } else {
      return true;
    }
  }) : [];
}

var expandMenu = function (menus, vectors, studio) {
  menus.forEach(menu => {
    if (menu.type != 'group') {
      var vector = vectors.find(x => x.id == menu.id);
      if (vector) {
        menu.name = vector.name;
        menu.emoji = vector.emoji;
        menu.children = [];
        if(studio) {
          menu.extension = { menus: vector.menus };
        } else {
          menu.children = vector.menus;
        }
      }
    }

    if (Array.isArray(menu.children)) {
      expandMenu(menu.children, vectors, studio);
    } else {
      menu.children = [];
    }
  });
}

var setChildMenu = function (menus, vector) {
  for(var menu of menus) {
    if(menu.id == vector.id.toString()) {
      let index = menus.indexOf(menu);
      if(index > -1) {
        vector.children = [];
        menus.splice(index, 1, vector);
      }

      //Vue.set(menu, 'children', vector.extension.menus);
      return;
      // menu.children = vector.extension.menus;
    }

    if (Array.isArray(menu.children)) {
      setChildMenu(menu.children, vector);
    }
  }
}

var expandSidebarMenu = function (parentId, menus) {
  let menu = _.findDeep(menus, x => (x.id == parentId), {
    childrenPath: 'children'
  })

  if (menu && menu.value && menu.value.id) {
    menu.value.open = true
    if (menu && menu.parent && menu.parent.id)
      expandSidebarMenu(menu.parent.id, menus)
  }
}
// get visible elements
var getVisibleElements = (elements, form) => {
  if (elements == null) {
    elements = [];
  }

  if (form && form.rows != null) {
    form.rows.forEach(row => {
      if (row.items != null) {
        row.items.forEach(item => {
          getVisibleInternalElements(elements, item);
        });
      }
    });
  }

  return elements;
}
var getVisibleInternalElements = (elements, item) => {
  if (item.visible !== false) {
    if (item.input == 'section') {
      //tab
      if (item.type == 'tab' && item.tabs) {
        item.tabs.forEach(tab => {
          if (tab.design) {
            getVisibleElements(elements, tab.design);
          }
        });
      }
      //design
      else if (item.design) {
        getVisibleElements(elements, item.design);
      }
    } else if(item && item.id) {
      let cloneItem = _.cloneDeep(item);
      if (cloneItem.type == 14 && cloneItem.fields && Array.isArray(cloneItem.fields) && cloneItem.fields.length) {
        cloneItem.fields = cloneItem.fields.filter(x => x.visible !== false && !x.hide);
      } else if (cloneItem.type == 15 && cloneItem.design) {
        cloneItem.fields = getVisibleElements(null, cloneItem.design);
      }
      elements.push(cloneItem);
    }
  }

  return elements;
}
// get validator elements
var getFormValidators = (elements, validatorKey) => {
  if (elements == null) {
    elements = [];
  }
  // filter exclude elements
  const validatorElements = elements.filter(x =>
    ["description", "image", "empty", 'button'].indexOf(x.input) === -1
  );
  // key
  const key = validatorKey || "fieldName";
  // validators
  let validators = {};
  validatorElements.forEach(x => validators[x[key]] = formValidator(x));
  return validators;
}
// form validator
var formValidator = function (x) {
  let validator = {}
  function boolean(val) {
    return val || false
  }

  if (x.readOnly) {
    return {}
  } else if (x.type == 14 || x.type == 15) {
    let requiredFields = {}
    if (x.fields && Array.isArray(x.fields) && x.fields.length) {
      x.fields.forEach(y => {
        requiredFields[y.fieldName] = formValidator(y)
      })
      return {
        required: requiredIf(() => x.required),
        $each: requiredFields
      }
    }
  } else if (x.required) {
    if (x.type == 1)
      validator = { required, boolean }
    else if (x.type == 22)
      validator = { required, htmlValidator }
    else
      validator = { required }
  }
  /* email */
  if (x.type == 25) 
    validator = { 
      ...validator, 
      email: (val) => val ? emailValidator(val) : true, 
    }
  /* phone */
  else if (x.type == 26)
    validator = {
      ...validator,
      phone: (val) => val ? phoneValidator(val) : true,
    }
  /* link */
  else if (x.type == 33)
    validator = { 
      ...validator, 
      url: (val) => val && val.constructor === String ? urlValidator(val) || uNCValidator(val)  : true,
    }
  /* custom validator */
  if (x.validator)
    validator = { ...validator, ...x.validator }

  return validator
}
// form visibility
var formElementVisibility = (x, formData) => {
  if (x.visible != null)
    return x.visible;

  // table / list
  if ((x.type == 14 || x.type == 15) && !x.isParent) {
    if (
      formElementVisibility({...x, isParent: true}, formData) && 
      x.fields && 
      Array.isArray(x.fields) && 
      x.fields.length
    )
      return !!(x.fields.filter(y => formElementVisibility(y)).length);
    else
      return false;
  }

  // table field => hide
  if (x.input === 'hidden' || x.hide === true)
    return false;

  // phase out (FTSControlModal)
  if (x.hiddenFunc && formData)
    return !x.hiddenFunc(formData);

  // phase out
  if (x.visibilityScript) {
    let data = formData;
    try {
      return eval(x.visibilityScript);
    } catch (ex) {
      return true;
    }
  }

  return true;
}
// element stop propagation
var elementStopPropagation = function (item) {
  const e = event;
  const className = (item && item.className || "stopPropagation").split(" ");
  const path = e.path || composedPath(e);
  for (let index = 0; index < path.length; index++) {
    const el = path[index];
    if (className.some(x => el.classList && el.classList.contains(x))) return true;
  }
  return false;
}
function composedPath(e) {
  if (e.composedPath)
    return e.composedPath();

  const path = []
  let el = e.target
  while (el) {
    path.push(el)

    if (el.tagName === 'HTML') {
      path.push(document)
      path.push(window)
      return path
    }

    el = el.parentElement
  }
  return path
}

var clientListViewRoute = function(payload) {
  let route = {
    name: 'list-view',
    params: { moduleId: encodeids(payload.moduleId) },
    query: {}
  }
  /* list id */
  if (payload.listId)
    route.query.l = payload.listId;
  /* entry id */
  if (
    payload.id &&
    (
      !payload.activity || 
      (
        payload.activity && payload.activity.toLowerCase != 'create'
      )
    )
  )
    route.query.id = encodeids(payload.id);
  /* activity id */
  if (payload.activity) 
    route.query.a = payload.activity;

  return route;
}

var clientPathUrl = function (payload) {
  let url = `/#/list/${encodeids(payload.moduleId)}`
  // list id
  if (payload.listId) {
    url += `?l=${payload.listId}`
  }
  // locus id
  if (
    payload.id &&
    (!payload.activity || (payload.activity && payload.activity.toLowerCase != 'create'))
  ) {
    if (payload.listId)
      url += `&id=${encodeids(payload.id)}`
    else
      url += `?id=${encodeids(payload.id)}`
  }
  // activity id
  if (payload.activity) {
    if (payload.listId || payload.id)
      url += `&a=${payload.activity}`
    else
      url += `?a=${payload.activity}`
  }
  return url
}

var imageLoader = function(src, success, error) {
  const img = new Image();
  img.onload = success;
  img.onerror = error;
  img.src = src;
}

function findElementById(elements, changeId, eleInput) {
  return elements.reduce((x, item) => {
    const input = item.input || eleInput
    if (x)
      return x
    if (item.id === changeId)
      return item
    if (item.fields && item.fields.some(y => y['id'] == changeId)) {
      return item.fields.find(y => y['id'] == changeId);
    }
    if (input === 'section' && item.type === 'tab' && item.tabs && item.tabs.length)
      return findElementById(item.tabs, changeId, input)
    if (input === 'section' && item.design && item.design.rows && item.design.rows.length)
      return findElementById(item.design.rows, changeId, input)
    if (item.items)
      return findElementById(item.items, changeId, input)
  }, null)
}

const formulaConstants = [
  {
    name: "CURRENT USER",
    fieldName: "CURRENTUSER",
    type: 19
  },
  {
    name: "TODAY",
    fieldName: "TODAY",
    type: 5
  },
  {
    name: "NOW",
    fieldName: "NOW",
    type: 5
  },
];

const formulaTemplates = [
  {
    name: 'if ... else ...',
    template: '<fts-i-unit contenteditable="false">value if true</fts-i-unit> if <fts-i-unit contenteditable="false">condition</fts-i-unit> else <fts-i-unit contenteditable="false">value if false</fts-i-unit> '
  },
  {
    name: 'or',
    template: '<fts-i-unit contenteditable="false">condition 1</fts-i-unit> or <fts-i-unit contenteditable="false">condition 2</fts-i-unit> '
  },
  {
    name: 'and',
    template: '<fts-i-unit contenteditable="false">condition 1</fts-i-unit> and <fts-i-unit contenteditable="false">condition 2</fts-i-unit> '
  },
  {
    name: 'condition',
    template: '<fts-i-unit contenteditable="false">value</fts-i-unit> == <fts-i-unit contenteditable="false">target</fts-i-unit> '
  },
  {
    name: 'sum',
    template: 'sum(<fts-i-unit contenteditable="false">table columns</fts-i-unit>)'
  },
  {
    name: 'filter',
    template: 'filter(<fts-i-unit contenteditable="false">table columns</fts-i-unit> == <fts-i-unit contenteditable="false">value</fts-i-unit>)'
  },
  // {
  //   name: 'sort items',
  //   template: 'sort(#Table.#Columns)'
  // },
  // {
  //   name: 'sort items',
  //   template: 'sort(#Table.#Columns)'
  // },
]

export default {
  expandWorkDesignInternal: expandWorkDesignInternal,
  findElementById: findElementById,
  model: model,
  defaultProfileImage: defaultProfileImage,
  fetiasLogo: fetiasLogo,
  iOSAppStoreURL: iOSAppStoreURL,
  androindPlayStoreURL: androindPlayStoreURL,
  websiteURL: websiteURL,
  communityURL: communityURL,
  youtubeURL: youtubeURL,
  facebookURL: facebookURL,
  twitterURL: twitterURL,
  linkedinURL: linkedinURL,
  discordURL: discordURL,
  blogURL: blogURL,
  newUUID: newUUID,
  nanoID: nanoID,
  encodeids: encodeids,
  decodeids: decodeids,
  standardActivityIcon: standardActivityIcon,
  informationIcon: informationIcon,
  expandInformationType: expandInformationType,
  getInformationIcon: getInformationIcon,
  informationTypes: informationTypes,
  standards: standards,
  standardActivities: standardActivities,
  camelize: camelize,
  getDisplayName: displayName,
  getFileColor: fileColor,
  getFileExtension: fileExtension,
  selectOptionBackground: selectOptionBackground,
  momentRelativeTime: momentRelativeTime,
  calendarRelativeTime: calendarRelativeTime,
  validDate: validDate,
  dateFormats: dateFormats,
  dateFormatTranslate: dateFormatTranslate,
  dragOptions: dragOptions,
  compactClassification: compactClassification,
  classificationInformation: classificationInformation,
  expandWorkDesign: expandWorkDesign,
  expandInformationFields: expandInformationFields,
  compactMenuDesign: compactMenuDesign,
  taskDueDateShortcuts: taskDueDateShortcuts,
  darkPalette: darkPalette,
  alphaPalette: alphaPalette,
  lightPalette: lightPalette,
  lightenPalette: lightenPalette,
  trimMenu: trimMenu,
  visibleMenu: visibleMenu,
  expandMenu: expandMenu,
  setChildMenu: setChildMenu,
  expandSidebarMenu: expandSidebarMenu,
  isImageFile: isImageFile,
  isInteger: isInteger,
  isNumber: isNumber,
  isArray: isArray,
  isObject: isObject,
  getVisibleElements: getVisibleElements,
  getFormValidators: getFormValidators,
  formElementVisibility: formElementVisibility,
  elementStopPropagation: elementStopPropagation,
  getAllElements: getAllElements,
  generateFieldName: generateFieldName,
  clientListViewRoute: clientListViewRoute,
  clientPathUrl: clientPathUrl,
  imageLoader: imageLoader,
  formulaConstants: formulaConstants,
  formulaTemplates: formulaTemplates
}